import { createReducer } from '@reduxjs/toolkit';
import * as Actions from './actions';

export interface GlossaryItem {
  Term: string;
  Definition: string;
}
export interface GlossaryState {
  loading: boolean;
  error: string;
  data: GlossaryItem[];
}
const defaultGlossaryState: GlossaryState = {
  loading: false,
  error: '',
  data: []
};

const glossaryReducer = createReducer(defaultGlossaryState, {
  [Actions.GET_GLOSSARY]: state => {
    state.loading = true;
  },
  [Actions.GET_GLOSSARY_FAIL]: (state, action) => {
    state.loading = false;
    state.error = action.error;
  },
  [Actions.GET_GLOSSARY_SUCCESS]: (state, action) => {
    state.loading = false;
    state.data = action.payload.data;
  }
});

export default glossaryReducer;
